<button type="button"
        class="ssab-icon icon-cursor ssab-consignment-label-button"
        [ngClass]="{'icon-red': itemHasErrors(currentItem),
        'icon-general-checklist': data !== null && data !== undefined && data.trim() !== '',
        'icon-general-contract': data === null || data === undefined || data.trim() === ''}"
        *ngIf="!readonly"
        (click)="openDialog(currentItem)">
</button>
